import styled from "styled-components";
import { FiSearch } from 'react-icons/fi';

export const SiteListContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 234px;
	height: 90vh;
	background-color: rgba(255, 255, 255, 1);
	box-shadow: 0px 10px 20px rgba(82, 82, 82, 0.1);
  overflow: auto;
	h1 {
		font-family: 'Suit extra bold', 'Inter bold';
		font-size: 20px;
		font-weight: 800;
		line-height: 22px;
		color: rgba(38, 38, 38, 1);
		padding: 20px;
	}
  @media screen and (min-width: 300px) and (max-width: 1000px) {
    width: 100%;
    height: 45vw;
    overflow: auto;
    h1 {
      font-size: 16px;
      line-height: 22px;
      padding: 15px;
    }
  }
  @media screen and (min-width: 1000px) and (max-width: 1200px) {
    width: 160px;
    h1 {
      font-size: 16px;
      line-height: 22px;
    }
  }
  @media screen and (min-width: 1920px) and (max-width: 2500px) {
    width: 370px;
    h1 {
      font-size: 24px;
      line-height: 28px;
    }
  }
  @media screen and (min-width: 2500px) and (max-width: 3500px) {
    width: 420px;
    h1 {
      font-size: 24px;
      line-height: 28px;
    }
  }
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
`;

export const SearchIcon = styled(FiSearch)`
  position: absolute;
  z-index: 10000;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(151, 151, 153, 1);
  font-size: 18px;
  @media screen and (min-width: 1920px) and (max-width: 5000px) {
    font-size: 24px;
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  height: 30px;
  border: solid 1px rgba(202, 201, 204, 1);
  background-color: #FFFFFF;
  border-radius: 4px;
  font-family: 'Suit regular', 'Inter regular';
  font-weight: 400;
  font-size: 12px;
  color: rgba(38, 38, 38, 1);
  text-indent: 12px;  
  &::placeholder {
    color: rgba(151, 151, 153, 1);
    opacity: 1;
    font-size: 12px;
    @media screen and (min-width: 1920px) and (max-width: 5000px) {
      font-size: 18px;
    }
  }
  
  &:disabled {
    background-color: rgba(250, 249, 252, 1);
    color: rgba(126, 126, 128, 1);
  }
  
  @media screen and (min-width: 1920px) and (max-width: 5000px) {
    height: 50px;
    font-size: 18px;
	}
`

export const StyledSiteList = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export const ListItem = styled.section<{status: boolean, activeSite: boolean}>`
	width: 100%;
	padding: 10px;
	border-bottom: 1px solid rgba(215, 215, 215, 1);
  @media screen and (min-width: 1920px) and (max-width: 5000px) {
    padding: 12px;
	}
`;

export const SiteCard = styled.div<{ activeSite: boolean }>`
  width: 100%;
  padding: 10px;
  background-color: ${({ activeSite }) =>
	activeSite ? "rgba(246, 242, 255, 1)" : "white"};
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.1s ease;
  &:hover {
    background-color: rgba(246, 242, 255, 1);
  }
`;

export const Title = styled.h3`
  font-family: 'Suit bold', 'Inter bold';
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  color: rgba(18, 6, 45, 1);
  @media screen and (min-width: 1920px) and (max-width: 5000px) {
    font-size: 20px;
    line-height: 32px;
	}
`;

export const Address = styled.h5`
  font-family: 'Suit regular', 'Inter regular';
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
  color: rgba(18, 6, 45, 1);
  margin-bottom: 10px;
  @media screen and (min-width: 1920px) and (max-width: 5000px) {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 15px;
      margin-top: 5px;
    }
`;

export const MetaInfo = styled.div`
	width: 100%;
  display: flex;
	flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const StatusBadge = styled.p<{ status: boolean }>`
  display: flex;
  align-items: center;
  font-size: 10px;
  padding: 4px 6px;
  border-radius: 5px;
  font-family: 'Suit regular', 'Inter regular';
  color: ${({ status }) => status ? "rgba(0, 51, 23, 1)" : "rgba(51, 10, 8, 1)"};
  border: 1px solid ${({ status }) => (status ? "rgba(0, 222, 102, 1)" : "rgba(253, 51, 38, 1)")};
  background-color: ${({ status }) => status ? "rgba(242, 255, 248, 1)" : "rgba(253, 241, 240, 1)"};
  @media screen and (min-width: 1920px) and (max-width: 5000px) {
    font-size: 16px;
    padding: 5px 12px;
  }
`;

export const StatusDot = styled.span<{ status: boolean }>`
  width: 5px;
  height: 5px;
  margin-right: 5px;
  border-radius: 50%;
  background-color: ${({ status }) =>
  status ? "rgba(0, 222, 102, 1)" : "rgba(253, 51, 38, 1)"};
`;

export const Divider = styled.div`
  width: 1px;
  height: 10px;
  background-color: rgba(215, 214, 217, 1);
`;

export const Usage = styled.p`
  font-family: 'Suit regular', 'Inter regular';
  font-size: 10px;
  line-height: 22px;
  color: rgba(38, 38, 38, 1);
`;
